import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Gastroenterology icon
 *
 * @category Medical
 */
const Gastroenterology = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.125 8.857c-.882-.894-1.976-1.587-3.187-1.928-2.047-.565-4.246-.083-6.245.635-.906.329-1.823.717-2.788.764s-2.022-.306-2.516-1.14c-.306-.53-.341-1.177-.377-1.8s-.059-1.259-.376-1.8c-.694-1.2-2.576-.917-3.14.236-.283.588-.318 1.258-.33 1.905-.035.976-.058 1.952.141 2.905.2.952.66 1.882 1.424 2.481 1.258.988 3.022.859 4.61 1.059.34.047.694.106.976.318.306.223.47.587.612.94.317.824.54 1.682.658 2.553.188 1.41.012 3.057-1.117 3.928-.894.682-2.129.67-3.234.494-1.106-.177-2.211-.518-3.329-.4-1.435.153-2.716 1.07-3.528 2.258s-1.188 2.634-1.317 4.07c-.036.364-.036.787.235 1.046.165.165.412.223.635.27 1.012.2 2.34.024 2.658-.952.188-.565.106-1.4.682-1.518a.96.96 0 0 1 .447.06c3.14.964 5.81 3.257 9.044 3.822 3.423.588 7.033-.965 9.256-3.623s3.152-6.268 2.893-9.726c-.14-1.882-.623-3.764-1.623-5.375a9 9 0 0 0-1.164-1.482m-11.655 2.34c-4.752.342-6.68-.634-6.245-5.962-.012-.623-.012-1.494.729-1.552.882-.024.87 1.023.859 1.787-.012 1.482.282 3 1.74 3.646.941.553 2.27.306 3.27.659.47.27.294 1.117-.2 1.364zM24.455 25.7c-3.505 3.07-9.256 3.799-12.35 0-.822-1.2-2.387-.353-3.421-1.176-1.6-1.282-2.905-.447-3.4 1.34-.14.365-.752.871-.976.471-.294-1.023.483-2.505.977-3.434.305-.506.564-.73.988-1 1.093-.764 3.104-.952 4.069-.059.47.318.223 1.388.788 1.612.835-.047 1.035-1.435 1.858-1.623a3.6 3.6 0 0 1 1.54-.247c1.435 0 2.612.964 3.67 1.893 1.094.576.659-.953.318-1.235-.388-.823-2.682-1.352-2.082-2.364.94-.611 2.682-.117 3.517.365.529.294.964.823 1.458 1.164.694.459.976-.294.576-.882-.223-.67-2.14-1.505-.835-1.976 1.435-.517.553-1.364-.611-1.046-1.083.34-1.965 1.41-3.2.635-1.41-.741.342-2.517-.517-3.423-1-1.07-1.294-2.846-.917-4.163.835-2.752 4.457-3 6.798-2.4 6.539 2.106 6.433 12.726 1.917 17.43l-.13.13z"
        />
      </svg>
    );
  }
);

Gastroenterology.displayName = 'Gastroenterology';

export { Gastroenterology };
